import { AnyAction } from 'redux';

import { fleetCleanFilters, fleetDefaultFilters } from '../../constants/FleetDefaultFilters';
import { COLLAPSE_ALL, SET_FILTER, SET_FILTER_DEFAULT, SET_FILTER_PARTIAL, SET_FILTER_CLEAN } from '../../constants/action-types';
import { EventFiltersState, initialEventFiltersState } from './eventFiltersState';

export const EventFiltersReducer = (state: EventFiltersState = initialEventFiltersState, action: AnyAction) => {
  switch (action.type) {
    case SET_FILTER:
      return {
        ...state,
        filter: {
          ...action.filter,
        },
      };
    case SET_FILTER_PARTIAL:
      return {
        ...state,
        filter: {
          ...state.filter,
          ...action.filterPartial,
        },
      };
    case SET_FILTER_DEFAULT:
      return { ...state, filter: fleetDefaultFilters(action.fleetId) };
    case SET_FILTER_CLEAN:
      return { ...state, filter: fleetCleanFilters() };
    case COLLAPSE_ALL:
      return {
        ...state,
        collapseTrigger: {}, // creates new object reference and triggers listeners
      };

    default:
      return state;
  }
};
